module.exports = __webpack_public_path__ + "img/breakdown-red.1136cb1c.svg";